// extracted by mini-css-extract-plugin
module.exports = {"Prose":"Prose_Prose__2zaJW","noTicker":"Prose_noTicker__3sk6A","march8":"Prose_march8__Zs3R1","inverse":"Prose_inverse__3gfXV"};